// GroupAlarmModal.tsx

import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslate } from "../../../hooks/LanguageProvider";
import { Bounce, toast } from "react-toastify";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface GroupAlarmModalProps {
  show: boolean;
  onHide: () => void;
  status: string | null; 
  title?: string | null; 
  IdUser: string; 
  idGroupAlarm: number; 
  updateGroupAlarmList: () => void;
}

const DeleteGroupAlarmModal: React.FC<GroupAlarmModalProps> = ({ show, onHide, status, title,IdUser, idGroupAlarm,updateGroupAlarmList  }) => {
  
  const { translate } = useTranslate();


  const deleteGroupAlarm = async (id_vehicule: number, id_user: string) => {


    try {
      const res = await fetch(`${backendUrl}/api/alarm/group/delete/${id_vehicule}/${id_user}`, {
        method: "DELETE",
        mode: "cors",
      });
      onHide();
      if (!res.ok) {
       
  
        console.error("Error deleting Group Alarm");
        status=null;
        toast.warn(translate("Can't deleting Group Alarm"), {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        
        return;
      }

      if (res.ok) {
       
        console.error(translate("Group deleted successfully"));
        updateGroupAlarmList();  
        toast.success("Group deleted successfully !", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        show=false;
        return;
      }


    } catch (error) {
      console.error("Error deleting GroupAlarm", error);


      toast.warn(translate("Can't deleting Group Alarm"), {
        position: "bottom-right",
        autoClose: 2500, 
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      
    } 
  };

 
 
  return ( 
    <Modal  show={show} onHide={onHide} centered>
      <Modal.Header closeButton> 
        <Modal.Title><i className="las la-las la-trash "></i>{ title || ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center"> 
        <p> {status || ""}</p>   
      </Modal.Body>  
      <Modal.Footer>
        <button  className="btn btn-outline-danger mt-2 mx-auto" onClick={onHide}> 
            {translate("Close")}
        </button>
        <button   className="btn btn-outline-success mt-2 mx-auto" onClick={() =>deleteGroupAlarm(idGroupAlarm,IdUser)}> 
          {translate("Delete")} 
        </button>
      </Modal.Footer>
    </Modal>
  );
};







export default DeleteGroupAlarmModal;
